export default {
  //tableName: 'instructionletter',
  display: ['name'],
  attributes: {    
    customerId: {
      model: "cliente",
      required: true
    },
    name:{
      type:'string',
    },
    address: {
      type: "string",
      required: true
    },
    rfc: {
      type: "string",
      required: true
    },
    email: {
      type: "string"
    },
    phone_number: {
      type: "string"
    },
    type_service: {
      model: "servicetypecatalogletter",
      required: true
    },
    reference: {
      type: "string",
    },
    incoterm: {
      type: "string",
      required: true
    },
    type_equipment: {
      model: "typeequipmentcatalog",
      required: true
    },
    pickup_address: {
      model: "location",
      required: true
    },
    pol: {
      model: "portcatalog",
      required: true
    },
    pod: {
      model: "portcatalog",
      required: true
    },
    delivery_address: {
      model: "location",
      required: true
    },
    description: {
      type: "string",
      required: true
    },
    tariff: {
      type: "number",
      required: true
    },
    type_packaging: {
      model: "typepackagingcatalog",
      required: true
    },
    volume: {
      type: "number",
      required: true
    },
    weight: {
      type: "number",
      required: true
    },
    cbm: {
      type: "string",
      required: true
    },
    quantity: {
      type: "number",
      required: true
    },
    lenght: {
      type: "number",
    },
    width: {
      type: "number",
    },
    height: {
      type: "number",
    },
    special_description: {
      type: "string",
      columnType: 'text',
    }
  }
};



// WEBPACK FOOTER //
// ./src/models/InstructionLetter.js